import React, { useState } from 'react';
import './Contact.css';
import { Phone, Envelope, MapPin, FacebookLogo, TwitterLogo, LinkedinLogo, YoutubeLogo, InstagramLogo } from '@phosphor-icons/react';
import RevealOnScroll from './RevealOnScroll';

const Contact = () => {
    const address = "Aikya Vihar, B-Block, Plot No.218, Kavuri Hills Phase 2 Rd, Doctor's Colony, Madhapur, Hyderabad, Telangana 500033.";
    const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.478500415475!2d78.3943735!3d17.436797199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915addcb8d41%3A0xb39810ca9bc05dc2!2sAikya%20Vihar!5e0!3m2!1sen!2sin!4v1773646150232!5m2!1sen!2sin";

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        // IMPORTANT: Replace this URL with your deployed Google Apps Script Web App URL
        const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzA3XVTcbHU2U3JcJQbd5SSBKvYgFLpCWX8KaZbIu6HgvHhrqZSy3CFrO_huUeFXd4/exec";


        try {
            const response = await fetch(SCRIPT_URL, {
                method: 'POST',
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setStatus({
                    type: 'success',
                    message: 'Thank you! Your message has been sent successfully.'
                });
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                throw new Error('Failed to send message');
            }
        } catch (error) {
            setStatus({
                type: 'error',
                message: 'Something went wrong. Please try again later.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="contact-section">
            <div className="contact-container">
                <div className="contact-header">
                    <RevealOnScroll>
                        <h1>Get in Touch</h1>
                        <p>We are always ready to help you and answer your questions. Drop us a message anytime and we’ll get back to you as soon as possible.</p>
                    </RevealOnScroll>
                </div>

                <div className="contact-content">
                    <div className="contact-info">
                        <RevealOnScroll delay={100}>
                            <div className="info-item">
                                <div className="info-icon">
                                    <Phone size={24} weight="fill" />
                                </div>
                                <div className="info-text">
                                    <h6>Contact us</h6>
                                    <p><a href="tel:+916304765654">+91 63047 65654</a></p>
                                    <p style={{ marginTop: '10px' }}>
                                        <a href="https://www.linkedin.com/in/vinushnalakkakula/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <LinkedinLogo size={18} weight="fill" /> Vinushna Lakkakula
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={200}>
                            <div className="info-item">
                                <div className="info-icon">
                                    <Envelope size={24} weight="fill" />
                                </div>
                                <div className="info-text">
                                    <h6>Email</h6>
                                    <p><a href="mailto:vinushna.lakkakula@cabptoidsolutions.com">vinushna.lakkakula@cabptoidsolutions.com</a></p>
                                </div>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={300}>
                            <div className="info-item">
                                <div className="info-icon">
                                    <MapPin size={24} weight="fill" />
                                </div>
                                <div className="info-text">
                                    <h6>Our Location</h6>
                                    <p>{address}</p>
                                </div>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={400}>
                            <div className="social-links">
                                <h6>Social network</h6>
                                <div className="social-icons">
                                    <a href="https://facebook.com/cabptoid" target="_blank" rel="noopener noreferrer"><FacebookLogo size={24} /></a>
                                    <a href="https://twitter.com/cabptoid" target="_blank" rel="noopener noreferrer"><TwitterLogo size={24} /></a>
                                    <a href="https://linkedin.com/company/cabptoid" target="_blank" rel="noopener noreferrer"><LinkedinLogo size={24} /></a>
                                    <a href="https://youtube.com/@cabptoid" target="_blank" rel="noopener noreferrer"><YoutubeLogo size={24} /></a>
                                    <a href="https://instagram.com/cabptoid" target="_blank" rel="noopener noreferrer"><InstagramLogo size={24} /></a>
                                </div>
                            </div>
                        </RevealOnScroll>
                    </div>

                    <div className="contact-form-container">
                        <RevealOnScroll delay={200}>
                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Your Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="subject"
                                        placeholder="Subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <textarea
                                        name="message"
                                        placeholder="Message"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button type="submit" className="submit-btn" disabled={loading}>
                                    {loading ? 'Sending...' : 'Send Message'}
                                </button>
                                {status.message && (
                                    <div className={`form-status ${status.type}`}>
                                        {status.message}
                                    </div>
                                )}
                            </form>
                        </RevealOnScroll>
                    </div>
                </div>

                <RevealOnScroll delay={400}>
                    <div className="map-container">
                        <iframe
                            title="Google Maps Location"
                            src={mapUrl}
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </RevealOnScroll>
            </div>
        </section>
    );
};

export default Contact;
